































import {Component, Watch, Mixins, Vue} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import {$, PageCollection, pushByName} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {MixinSelect} from '@/components/mixins/MixinSelect'
import {Role} from '@/enums/Role'
import {AppConfig} from '@/config/app.config'
import Responsavel from '@/model/resource/Responsavel'
import TipoOcorrencia from '@/model/resource/TipoOcorrencia'

const metaInfo = () => ({
  title: $.t('view.manage.occurrenceTypeList.title'),
})

@Component({
  metaInfo,
})
export default class ManageOccurrenceTypeListView extends Mixins(MixinFilter, MixinSelect) {
  @Getter('auth/role') role!: Role
  @Getter('auth/responsavel') user!: Responsavel

  Role = Role
  AppConfig = AppConfig
  pushByName = pushByName

  collection = new PageCollection(TipoOcorrencia, {}, 10)

  created() {
    this.collection.endpoint = '/user/tipo-ocorrencia/responsavel'
    this.collection.orderBy = 'ativo'
    this.collection.asc = false
  }
}
